// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_Hxxs8 {
    z-index: 999;
    position: absolute;
  }
  .bg_sFode {
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-color: var(--_00000020-background);
    top: 0;
    left: 0;
    z-index: 7;
  }
  .addLocationContainer_vjVXn {
    overflow: hidden;
    width: 100%;
    max-width: 550px;
    box-sizing: border-box;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    position: fixed;
    top: 50%;
    left: 50%;
    background-color: var(--white-color);
    transform: translate(-50%, -50%);
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
    animation: scaleUp_B2msF 300ms ease-out forwards;
    z-index: 9;
    @media (width<768px) {
      height: 100vh;
      width: 100vw;
      max-width: 100vw;
    }
  }

  .addLocationContent_iwmBt {
    padding: 20px;
    max-height: 300px;
    overflow-y: auto;
    input[type="checkbox"] {
      accent-color: var(--_10a37f-background);
    }
    
    table {
      border-collapse: collapse; 
    }
    table thead {
      font-size: 13px;
    }

    .small_A252C {
      min-width: 10px;
      max-width: 30px;
    }
    .selectedRow_tsu8z {
      background-color: var(--eeeeef-background);
    }

  }

  .scaleDown_wR4bQ {
    animation: scaleDown_wR4bQ 300ms ease-in forwards;
    -webkit-animation: scaleDown_wR4bQ 300ms ease-in forwards;
  }

  @keyframes scaleUp_B2msF {
    from {
      transform: translate(-50%, -50%) scale(0);
      -webkit-transform: translate(-50%, -50%) scale(0);
      -moz-transform: translate(-50%, -50%) scale(0);
      -ms-transform: translate(-50%, -50%) scale(0);
      -o-transform: translate(-50%, -50%) scale(0);
    }
    to {
      transform: translate(-50%, -50%) scale(1);
      -webkit-transform: translate(-50%, -50%) scale(1);
      -moz-transform: translate(-50%, -50%) scale(1);
      -ms-transform: translate(-50%, -50%) scale(1);
      -o-transform: translate(-50%, -50%) scale(1);
    }
  }

  @keyframes scaleDown_wR4bQ {
    from {
      transform: translate(-50%, -50%) scale(1);
    }
    to {
      transform: translate(-50%, -50%) scale(0);
      -webkit-transform: translate(-50%, -50%) scale(0);
      -moz-transform: translate(-50%, -50%) scale(0);
      -ms-transform: translate(-50%, -50%) scale(0);
      -o-transform: translate(-50%, -50%) scale(0);
    }
  }

  .fadeOut_Eo9VJ {
    opacity: 0;
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/AddLocation/AddLocation.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,aAAa;IACb,YAAY;IACZ,6CAA6C;IAC7C,MAAM;IACN,OAAO;IACP,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,gCAAgC;IAKhC,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;IAC5C,gDAA0C;IAC1C,UAAU;IACV;MACE,aAAa;MACb,YAAY;MACZ,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB;MACE,uCAAuC;IACzC;;IAEA;MACE,yBAAyB;IAC3B;IACA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,eAAe;IACjB;IACA;MACE,0CAA0C;IAC5C;;EAEF;;EAEA;IACE,iDAA2C;IAC3C,yDAAmD;EACrD;;EAEA;IACE;MACE,yCAAyC;MACzC,iDAAiD;MACjD,8CAA8C;MAC9C,6CAA6C;MAC7C,4CAA4C;IAC9C;IACA;MACE,yCAAyC;MACzC,iDAAiD;MACjD,8CAA8C;MAC9C,6CAA6C;MAC7C,4CAA4C;IAC9C;EACF;;EAEA;IACE;MACE,yCAAyC;IAC3C;IACA;MACE,yCAAyC;MACzC,iDAAiD;MACjD,8CAA8C;MAC9C,6CAA6C;MAC7C,4CAA4C;IAC9C;EACF;;EAEA;IACE,UAAU;EACZ","sourcesContent":[".overlay {\n    z-index: 999;\n    position: absolute;\n  }\n  .bg {\n    position: fixed;\n    height: 100vh;\n    width: 100vw;\n    background-color: var(--_00000020-background);\n    top: 0;\n    left: 0;\n    z-index: 7;\n  }\n  .addLocationContainer {\n    overflow: hidden;\n    width: 100%;\n    max-width: 550px;\n    box-sizing: border-box;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    background-color: var(--white-color);\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n    animation: scaleUp 300ms ease-out forwards;\n    z-index: 9;\n    @media (width<768px) {\n      height: 100vh;\n      width: 100vw;\n      max-width: 100vw;\n    }\n  }\n\n  .addLocationContent {\n    padding: 20px;\n    max-height: 300px;\n    overflow-y: auto;\n    input[type=\"checkbox\"] {\n      accent-color: var(--_10a37f-background);\n    }\n    \n    table {\n      border-collapse: collapse; \n    }\n    table thead {\n      font-size: 13px;\n    }\n\n    .small {\n      min-width: 10px;\n      max-width: 30px;\n    }\n    .selectedRow {\n      background-color: var(--eeeeef-background);\n    }\n\n  }\n\n  .scaleDown {\n    animation: scaleDown 300ms ease-in forwards;\n    -webkit-animation: scaleDown 300ms ease-in forwards;\n  }\n\n  @keyframes scaleUp {\n    from {\n      transform: translate(-50%, -50%) scale(0);\n      -webkit-transform: translate(-50%, -50%) scale(0);\n      -moz-transform: translate(-50%, -50%) scale(0);\n      -ms-transform: translate(-50%, -50%) scale(0);\n      -o-transform: translate(-50%, -50%) scale(0);\n    }\n    to {\n      transform: translate(-50%, -50%) scale(1);\n      -webkit-transform: translate(-50%, -50%) scale(1);\n      -moz-transform: translate(-50%, -50%) scale(1);\n      -ms-transform: translate(-50%, -50%) scale(1);\n      -o-transform: translate(-50%, -50%) scale(1);\n    }\n  }\n\n  @keyframes scaleDown {\n    from {\n      transform: translate(-50%, -50%) scale(1);\n    }\n    to {\n      transform: translate(-50%, -50%) scale(0);\n      -webkit-transform: translate(-50%, -50%) scale(0);\n      -moz-transform: translate(-50%, -50%) scale(0);\n      -ms-transform: translate(-50%, -50%) scale(0);\n      -o-transform: translate(-50%, -50%) scale(0);\n    }\n  }\n\n  .fadeOut {\n    opacity: 0;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_Hxxs8`,
	"bg": `bg_sFode`,
	"addLocationContainer": `addLocationContainer_vjVXn`,
	"scaleUp": `scaleUp_B2msF`,
	"addLocationContent": `addLocationContent_iwmBt`,
	"small": `small_A252C`,
	"selectedRow": `selectedRow_tsu8z`,
	"scaleDown": `scaleDown_wR4bQ`,
	"fadeOut": `fadeOut_Eo9VJ`
};
export default ___CSS_LOADER_EXPORT___;
